const LEGAL_COMPLIANCE_API_BASE_URL = "/legal_compliances";

export const LEGAL_COMPLIANCE_API_ENDPOINTS = {
  CURRENT: `${LEGAL_COMPLIANCE_API_BASE_URL}/current`,
  ACCEPT: `${LEGAL_COMPLIANCE_API_BASE_URL}/accept`,
  DOWNLOAD_CURRENT: `${LEGAL_COMPLIANCE_API_BASE_URL}/download_current`,
} as const;

// Public, unauthenticated routes at the API root (outside `/api/benef`).
export const LEGAL_DOCUMENTS_PUBLIC_PATH = "/api/legal/documents";

// Acceptance screen this front renders: publication text readable in place,
// links to its frozen notices, an unchecked box carrying `action_label`, then
// a separate optional preferences step and a recap. Bump it with the API
// (AcceptanceRecorder::PRESENTATION_VERSION) whenever that screen changes.
export const LEGAL_COMPLIANCE_PRESENTATION_VERSION = "cgu-post-login-v4";

export const LEGAL_COMPLIANCE_QUERY_KEYS = {
  current: () => ["legalCompliance", "current"] as const,
  publicDocuments: () => ["legalCompliance", "publicDocuments"] as const,
};

export const LEGAL_COMPLIANCE_ALLOWED_TAGS = [
  "p", "h2", "h3", "strong", "b", "em", "i", "u", "ul", "ol", "li", "a", "br",
];

// Notices may carry tables (cookie inventory).
export const LEGAL_DOCUMENT_ALLOWED_TAGS = [
  ...LEGAL_COMPLIANCE_ALLOWED_TAGS, "table", "thead", "tbody", "tr", "th", "td",
];

// External links of a legal text open in a new tab, so the reader keeps his
// place in it; the sanitiser drops `target` unless told otherwise.
export const LEGAL_LINK_ALLOWED_ATTRIBUTES = ["target"];

export const LEGAL_COMPLIANCE_UPDATED_AT_FORMATTER = new Intl.DateTimeFormat("fr-FR", {
  dateStyle: "long",
  timeZone: "Europe/Paris",
});

export const LEGAL_COMPLIANCE_CONTENT_CLASS =
  "[&_h2]:text-xl [&_h2]:font-semibold [&_h3]:text-lg [&_h3]:font-semibold [&_p]:mb-4 [&_ul]:list-disc [&_ol]:list-decimal [&_ul]:pl-6 [&_ol]:pl-6 [&_li]:mb-1 [&_a]:text-primary [&_a]:underline";

export const LEGAL_DOCUMENT_CONTENT_CLASS =
  `${LEGAL_COMPLIANCE_CONTENT_CLASS} [&_table]:mb-4 [&_table]:w-full [&_table]:text-sm [&_th]:border [&_th]:p-2 [&_th]:text-left [&_td]:border [&_td]:p-2 [&_td]:align-top`;

// The privacy notice is also linked from the login attestation sentence.
export const PRIVACY_DOCUMENT_KEY = "privacy";

export const LEGAL_COMPLIANCE_COPY = {
  TITLE: "Un cadre clair, pour bien commencer.",
  UPDATE_TITLE: "Nos conditions évoluent.",
  DOCUMENT_TITLE: "Conditions générales d'utilisation",
  READ_DOCUMENT: "Lire",
  DOWNLOAD: "Télécharger les conditions générales d'utilisation",
  DOWNLOAD_ERROR: "Le téléchargement n'a pas abouti. Réessayez.",
  VERSION_PREFIX: "Version",
  CHANGE_SUMMARY_PREFIX: "Ce qui change :",
  FIRST_ACCEPTANCE_INTRO:
    "Votre CSE vous donne accès à Yeati. Avant d'entrer, prenez connaissance de nos conditions d'utilisation.",
  UPDATE_INTRO: "Prenez connaissance de la nouvelle version pour continuer à profiter de vos avantages.",
  PRIVACY_LINKS_LABEL: "Vos données",
  ACCEPT: "Accepter et continuer",
  REFUSE: "Me déconnecter",
  CANNOT_ACCEPT:
    "Seul le salarié peut accepter les conditions générales d'utilisation. Connectez-vous directement avec votre compte pour les accepter.",
  PRESENTATION_OUTDATED_NOTICE:
    "Cette page n'est plus à jour. Rechargez-la pour afficher la version actuelle des conditions générales d'utilisation.",
  RELOAD_PAGE: "Recharger la page",
  OUTDATED_NOTICE:
    "Les conditions générales d'utilisation viennent d'être mises à jour. Relisez la nouvelle version avant de l'accepter.",
  ACCEPT_ERROR: "L'enregistrement n'a pas abouti. Votre accord n'a pas été enregistré. Réessayez.",
  LOAD_ERROR: "Les conditions générales d'utilisation n'ont pas pu être chargées.",
  RETRY: "Réessayer",
  LOGOUT: "Se déconnecter",
  LOADING: "Chargement des conditions générales d'utilisation…",
  LOGIN_DOCUMENTS_LABEL: "Informations légales",
  REFUSAL_MESSAGE:
    "L'utilisation des services de Yeati, en accord avec votre CSE, nécessite que vous acceptiez les conditions générales d'utilisation.",
} as const;
